import { Column, Row } from '@components/LinearLayout';

import { P } from '@components/Typography';
import styled from 'styled-components';

export const FormItemsWrapper = styled(Row)`
  flex-wrap: wrap;
  gap: 4%;
  padding: 3rem 0 2rem 0rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 1rem 0 2.5rem 1rem;
  }
`;

export const FormItemWrapper = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
`;

export const RegistrationFormRoot = styled.div<{ $fullWidth?: boolean }>`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '114%')};
  
  box-sizing: border-box;

  height: 100%;
  width: 100%;
  padding-bottom: 2.5rem;
  padding-right: 1rem;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    width: 100%;
  }
`;

export const CheckboxText = styled(P)<{ $required?: boolean }>`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size14};
  line-height: ${({ theme }) => theme.lineHeight.height135};

  ${({ $required, theme }) =>
    $required &&
    `&::after {
    content: '*';
    font-size: ${theme.fontSize.size16};
    font-weight: ${theme.fontWeight.weight900};
    line-height: ${theme.lineHeight.height150};
  }`}
`;

export const HintText = styled(P)`
  padding-top: 2rem;
  font-size: ${({ theme }) => theme.fontSize.size14};
  color: ${({ theme }) => theme.color.mobilityGrey};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  &:hover {
    color: ${({ theme }) => theme.color.mobilityGrey3};
  }
`;

export const FormItemContainer = styled(Column)`
  gap: 2.5rem;
  padding-bottom: 2rem;
  padding-left: 1rem;
`;
